var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"3","y1":"12","x2":"21","y2":"12","key":0}),React.createElement("line",{"x1":"3","y1":"6","x2":"21","y2":"6","key":1}),React.createElement("line",{"x1":"3","y1":"18","x2":"21","y2":"18","key":2})]);
}

MenuIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-menu"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
